import { Component, OnInit } from '@angular/core';
import { AhsTranslationService } from '@nx-ahs/base-translate';
import { LanguageService } from '../../../core/services/language.service';
import { AppCoreService } from '../../../core/services/app-core.service';
import { PublicLayoutService } from '../../../shared/services/public-layout.service';
import { PublicLayoutBase } from '../../../shared/components/layout/public-layout/public-layout-base';

@Component({
	selector: 'ahs-maintenance',
	templateUrl: './maintenance.component.html',
	styleUrls: ['./maintenance.component.scss'],
	standalone: false
})
export class MaintenanceComponent extends PublicLayoutBase implements OnInit {
	public loaded = false;
	public isLive = true;
	public isDBReady = true;
	public currentYear: number;

	constructor(
		public translateService: AhsTranslationService,
		private languageService: LanguageService,
		private appCoreService: AppCoreService,
		protected publicLayoutService: PublicLayoutService
	) {
		super(publicLayoutService);
	}

	async ngOnInit() {
		this.isLive = this.appCoreService.isLive;
		this.isDBReady = this.appCoreService.isDBReady;
		this.currentYear = new Date().getFullYear();

		if (this.isLive) {
			await this.languageService
				.getLanguagesForPublicPage('maintenance')
				.toPromise()
				.then((language) => {
					this.translateService.loadTranslations(...language.locales);
					this.loaded = true;
				})
				.catch(() => {
					console.log('error translation');
				});
		}

		this.loaded = true;
	}
}
